import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import Position from '../../marvel-ui-position/Position';
import Loader from '../../marvel-ui-loader/Loader';

import generalStyles from './style/general.css';
import stateStyles from './style/state.css';
import typeStyles from './style/type.css';

export default function Card({
  cardCount,
  children,
  isDisabled,
  isDragged,
  isLoading,
  isSelected,
  type,
}) {
  const outerClass = cx(generalStyles.outer, {
    [stateStyles.dragging]: cardCount,
  });

  const cardClass = cx(generalStyles.card, {
    [stateStyles.multiple]: cardCount,
    [stateStyles.disabled]: isDisabled && !cardCount,
    [stateStyles.dragging]: isDragged && !cardCount,
    [stateStyles.selected]: isSelected && !cardCount,
    [typeStyles[type]]: !isSelected && !isDragged && !cardCount,
  });

  return (
    <div className={outerClass}>
      {cardCount && <div className={generalStyles.extraElement} />}
      <div className={cardClass}>
        {isLoading ? (
          <Position location="all">
            <Loader />
          </Position>
        ) : (
          children
        )}
      </div>
      {cardCount && <div className={generalStyles.cardCount}>{cardCount}</div>}
    </div>
  );
}

Card.propTypes = {
  cardCount: PropTypes.number,
  children: PropTypes.node.isRequired,
  isDisabled: PropTypes.bool,
  isDragged: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSelected: PropTypes.bool,
  type: PropTypes.oneOf(Object.keys(typeStyles)),
};

Card.defaultProps = {
  type: 'default',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-card/Card/index.js